module.exports = __webpack_public_path__ + "img/tor_3.86b0c1d6.jpg";